import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
}
import { Layout } from "./components/layout/Layout";
import { HomePage } from "./pages/HomePage";
import { ChiSiamoPage } from "./pages/ChiSiamoPage";
import { ProdottiPage } from "./pages/ProdottiPage";
import { NegozioPage } from "./pages/NegozioPage";
import { GalleriaPage } from "./pages/GalleriaPage";
import { NewsPage, NewsDetailPage } from "./pages/NewsPage";
import { RecensioniPage } from "./pages/RecensioniPage";
import { ContattiPage } from "./pages/ContattiPage";
import AdminPage from "./pages/admin/AdminPage";
import IntroVideo from "./components/IntroVideo";
import { CartProvider } from "./context/CartContext";

function App() {
  return (
    <div className="App">
      <CartProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Admin — niente IntroVideo qui */}
          <Route path="/admin/*" element={<AdminPage />} />

          {/* Sito pubblico — IntroVideo SOLO qui, smontato quando si va su /admin */}
          <Route
            path="/*"
            element={
              <>
                <IntroVideo />
                <Layout>
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/chi-siamo" element={<ChiSiamoPage />} />
                    <Route path="/prodotti" element={<ProdottiPage />} />
                    <Route path="/negozio" element={<NegozioPage />} />
                    <Route path="/galleria" element={<GalleriaPage />} />
                    <Route path="/news" element={<NewsPage />} />
                    <Route path="/news/:id" element={<NewsDetailPage />} />
                    <Route path="/recensioni" element={<RecensioniPage />} />
                    <Route path="/contatti" element={<ContattiPage />} />
                  </Routes>
                </Layout>
                <Toaster position="top-right" richColors />
              </>
            }
          />
        </Routes>
      </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
